import type { RouteInfo } from './types'
import { BIReporter, ILogger, InternalNavigationType, NavigationLoggerStringMap } from '@wix/thunderbolt-symbols'
import { filterAndStringifyParamsOverrides } from './navigationMonitoringUtils'

export const reportNavigationStart = (
	currentNavInfo: RouteInfo | null,
	routeInfo: Partial<RouteInfo> | null,
	biReporter: BIReporter,
	logger: ILogger,
	pageNumber: number
) => {
	if (currentNavInfo) {
		// will be `undefined` in first render / load, we don't want to report it
		biReporter.reportPageNavigation(routeInfo?.pageId)
		logger.interactionStarted('page-navigation', {
			paramsOverrides: filterAndStringifyParamsOverrides({ pageId: routeInfo?.pageId, pn: pageNumber }),
		})
	}
}

export const reportNavigationEnd = (
	currentNavInfo: RouteInfo | null,
	routeInfo: Partial<RouteInfo> | null,
	navigationType: InternalNavigationType,
	biReporter: BIReporter,
	logger: ILogger,
	pageNumber: number
) => {
	/**
	 * In SSR currentNavInfo will be `undefined` in first render / load, we don't want to report it
	 * In password protected pages we don't have currentNavInfo, but we want to report the navigation
	 *  */
	const anchorDataId = routeInfo?.anchorDataId ?? 'SCROLL_TO_TOP'
	if (currentNavInfo || routeInfo?.biData?.pageType === 'password-protected') {
		biReporter.reportPageNavigationDone(routeInfo?.pageId, navigationType)
		logger.setGlobalsForErrors({ tags: { pageId: routeInfo?.pageId } })
		logger.interactionEnded(NavigationLoggerStringMap[navigationType], {
			paramsOverrides: filterAndStringifyParamsOverrides({
				pageId: routeInfo?.pageId,
				pn: pageNumber,
				navHasScrollToAnchor: anchorDataId !== 'SCROLL_TO_TOP',
				navAnimate: routeInfo?.biData?.navAnimate,
				navType: routeInfo?.type?.toLowerCase(),
				pageType: routeInfo?.biData?.pageType,
			}),
		})
	}
}
